import React, { useState, useRef } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { TextField, Button, CircularProgress } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';

import './contactform.scss';

const Contactform = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        web: 'futurerockstars.cz'
    });

    const [fieldErrors, setFieldErrors] = useState({
        name: false,
        email: false,
        phone: false,
        message: false,
    });

    const nameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const messageRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const theme = createMuiTheme({
        palette: {
            primary: {
                main: '#333333',
            },
        },
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (fieldErrors[e.target.name]) {
            setFieldErrors({ ...fieldErrors, [e.target.name]: false });
        }
    };

    // Define the Google Ads conversion tracking function
    const gtag_report_conversion = (url) => {
        const callback = function () {
            if (typeof(url) != 'undefined') {
                window.location = url;
            }
        };
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-10999420374/vfQQCInep_sYENar9_wo',
                'event_callback': callback
            });
        }
        return false;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

// Check for empty required fields and set errors
        const newErrors = {
            name: !formData.name,
            email: !formData.email,
            phone: !formData.phone,
            message: !formData.message,
        };

        setFieldErrors(newErrors);

// If any field has an error, focus on the first empty field and stop the submission process
        if (newErrors.name || newErrors.email || newErrors.phone || newErrors.message) {
            if (newErrors.name) {
                nameRef.current.focus();
            } else if (newErrors.email) {
                emailRef.current.focus();
            } else if (newErrors.phone) {
                phoneRef.current.focus();
            } else if (newErrors.message) {
                messageRef.current.focus();
            }
            return;
        }

        setIsSubmitting(true);

// Introduce a minimum delay of 2 seconds
        const minimumDelay = new Promise(resolve => setTimeout(resolve, 800));

        try {
            const submitForm = axios.post('https://services.futurerockstars.cz/ftrs-webmailer', formData);

// Wait for both the form submission and the minimum delay to complete
            await Promise.all([submitForm, minimumDelay]);

            // Call Google Ads Conversion Tracking
            gtag_report_conversion();

            setFormData({ name: '', email: '', phone: '', message: '', web: 'futurerockstars.cz' });
            setSubmitSuccess(true);
        } catch (error) {
            console.error('Submission error:', error);
        } finally {
            setIsSubmitting(false);
            setTimeout(() => {
                setSubmitSuccess(false);
            }, 3000); // Reset submitSuccess after 3 seconds
        }
    };

    return (
        <div className="ftrs-contactform">
            <Container className="pt-5 pb-5">
                <h2 className="ftrs-h2 mb-5" data-sal="fade" data-sal-duration="1000">
                    Domluvte si s&nbsp;námi bezplatnou konzultaci
                </h2>
                <Row>
                    <Col xs="12" lg="6" data-sal="fade" data-sal-delay="250" data-sal-duration="1000" className="order-2 order-lg-1">
                        <form className="ftrs-contactform__form" onSubmit={handleSubmit} noValidate>
                            <ThemeProvider theme={theme}>
                                <TextField
                                    inputRef={nameRef}
                                    required
                                    label="Vaše jméno"
                                    name="name"
                                    error={fieldErrors.name}
                                    helperText={fieldErrors.name ? "Prosím, vyplňte jméno." : ""}
                                    value={formData.name}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                />
                                <TextField
                                    className="ftrs-contactform__text2"
                                    label="Společnost"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                />
                                <TextField
                                    inputRef={emailRef}
                                    required
                                    label="E-mail"
                                    name="email"
                                    error={fieldErrors.email}
                                    helperText={fieldErrors.email ? "Prosím, vyplňte e-mail." : ""}
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                />
                                <TextField
                                    inputRef={phoneRef}
                                    required
                                    label="Telefon"
                                    name="phone"
                                    error={fieldErrors.phone}
                                    helperText={fieldErrors.phone ? "Prosím, vyplňte telefon." : ""}
                                    type="tel"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                />
                                <TextField
                                    inputRef={messageRef}
                                    required
                                    label="Vaše zpráva"
                                    name="message"
                                    error={fieldErrors.message}
                                    helperText={fieldErrors.message ? "Prosím, vyplňte zprávu." : ""}
                                    multiline
                                    rows={4}
                                    value={formData.message}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                />
                                <input name="web" value="futurerockstars.cz" type="hidden"></input>
                                <Button
                                    className={`mt1 mb3 ftrs-contactform__button ${submitSuccess ? 'ftrs-contactform__button--wide' : ''}`}
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <CircularProgress style={{ color: '#fff' }} size={24} />
                                    ) : submitSuccess ? (
                                        <span>
                                            <FontAwesomeIcon icon={faRocket} /> úspěšně odesláno
                                        </span>
                                    ) : (
                                        'Odeslat'
                                    )}
                                </Button>
                            </ThemeProvider>
                        </form>
                    </Col>
                    <Col xs="12" lg="6" data-sal="fade" data-sal-delay="250" data-sal-duration="1000" className="order-1 order-lg-2">
                        <h3 className="ftrs-h3 mt1 mb1" data-sal="fade" data-sal-duration="1000">
                            Získejte odpovědi na tyto otázky:
                        </h3>
                        <ul className="mb3">
                            <li>Kolik to bude stát a&nbsp;co ovlivňuje cenu?</li>
                            <li>Jak dlouho trvá vývoj?</li>
                            <li>Jakou součinnost budeme od&nbsp;Vás očekávat?</li>
                            <li>Jak probíhá spolupráce a&nbsp;jak budete průběžně informováni?</li>
                            <li>Jaké technologie Vám doporučíme?</li>
                            <li>Jak lze aplikaci modernizovat/vyvíjet a&nbsp;zároveň využívat?</li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Contactform;
